/**
 * Every holiday query sits under this, per department, so one invalidation refreshes them all. Kept apart from the
 * queries so the schedule's refresh can invalidate them without loading the holiday query hooks.
 */
export const HOLIDAY_GROUPS_QUERY_KEY = "holiday-groups";
export const holidayDepartmentKey = (departmentId: string) => [HOLIDAY_GROUPS_QUERY_KEY, departmentId] as const;
